'use client';
import { Divider } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import {
    CarGarage,
    Cross,
    HomeTestDrive,
    Money,
    See,
    SeeCarIcon,
    ShieldTick,
    ShieldTickModal,
    Tick,
} from '../../../../../public/Images';
import { useState } from 'react';
import Modal from '@/components/shared/modal.component';
import Typography from '@/components/shared/typography/typography.component';

import styles from './styles.module.scss';

import { useTranslation, useWindowDimensions } from '@/hook';
import { numberWithCommas } from '@/utils';
import {
    NEXT_APP_RETAIL_HOME_RESERVE_FEES,
    NEXT_APP_RETAIL_RESERVE_FEES,
    NEXT_APP_RETAIL_WINCH_FEES,
} from '@/constants';
//@TODO :: MOVE ANY WIDTH HANDLE TO CSS.
export default function ReserveSeeCarBanner({
    variant,
}: {
    variant: 'banner' | 'card';
}) {
    const [showLabel, setShowLabel] = useState(false);
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const IS_RTL = lang === 'ar';
    const { width } = useWindowDimensions();
    const IS_DESKTOP = width > 850;

    const RESERVE_MODAL_SECTIONS = [
        {
            icon: HomeTestDrive,
            title: 'HomeTestDrive',
            price: `${numberWithCommas(NEXT_APP_RETAIL_HOME_RESERVE_FEES)} ${t(
                'EGP'
            )}`,
            benefits: [
                {
                    icon: Tick,
                    text: t('CarReserved'),
                },
                {
                    icon: Tick,
                    text: t('TestDriveIncluded'),
                },
                {
                    icon: Tick,
                    text: t('CarDelivery', {
                        winchFees: numberWithCommas(NEXT_APP_RETAIL_WINCH_FEES),
                    }),
                },
                {
                    icon: Money,
                    text: t('RefundableFees', {
                        reserveFees: numberWithCommas(
                            NEXT_APP_RETAIL_RESERVE_FEES
                        ),
                    }),
                },
            ],
        },
        {
            icon: CarGarage,
            title: 'SylndrHub',
            price: `${numberWithCommas(NEXT_APP_RETAIL_RESERVE_FEES)} ${t(
                'EGP'
            )}`,
            benefits: [
                {
                    icon: Tick,
                    text: t('CarReserved'),
                },
                {
                    icon: Tick,
                    text: t('TestDriveAvailable'),
                },
                {
                    icon: Money,
                    text: t('RefundableFees', {
                        reserveFees: numberWithCommas(
                            NEXT_APP_RETAIL_RESERVE_FEES
                        ),
                    }),
                },
            ],
        },
    ];
    const SEE_MODAL_SECTIONS = [
        {
            icon: Tick,
            text: t('CarAvailableSylndrHub'),
        },
        {
            icon: Cross,
            text: t('CarNotReserved'),
        },
        {
            icon: Cross,
            text: t('NoTestDrive'),
        },
    ];

    const banner = () => {
        const backgroundColor = IS_RTL
            ? 'linear-gradient(to left, #002d5d 0%, #002d5d 46%, #002246 47%, #002246 100%)'
            : 'linear-gradient(to right, #002d5d 0%, #002d5d 46%, #002246 47%, #002246 100%)';
        const backgroundColorMobile = IS_RTL
            ? 'linear-gradient(to left, #002d5d 0%, #002d5d 49%, #002246 47%, #002246 100%)'
            : 'linear-gradient(to right, #002d5d 0%, #002d5d 49%, #002246 47%, #002246 100%)';
        return (
            <div
                /* @ts-ignore */
                variant="banner"
                className={`${styles.reserve_see_container}`}
                style={{
                    background: IS_DESKTOP
                        ? backgroundColor
                        : backgroundColorMobile,
                    display: 'grid',
                    gridTemplateAreas: '"r b" "s s"',
                    gridAutoColumns: '49%',
                }}
            >
                <div
                    className={styles.content_container}
                    style={{ gridArea: 'r' }}
                    /* @ts-ignore */
                    rtl={IS_RTL ? 'rtl' : 'ltr'}
                    variant={'banner'}
                    skew={IS_DESKTOP ? 'skew' : null}
                >
                    <div className={styles.header_container}>
                        <img
                            src={ShieldTick.src}
                            alt=""
                            fetchPriority={'low'}
                        />
                        <Typography color="white" variant="subtitle2Bold">
                            {t('ReserveCar')}
                        </Typography>
                    </div>
                    <Typography color="white" variant="body2">
                        {t('ReserveCarDescription')}
                    </Typography>
                </div>
                {/* @ts-ignore */}
                <div
                    className={styles.content_container}
                    style={{ gridArea: 'b' }}
                >
                    <div className={styles.header_container}>
                        <img
                            src={SeeCarIcon.src}
                            alt="SeeCarIcon"
                            fetchPriority={'low'}
                        />
                        <Typography color="white" variant="subtitle2Bold">
                            {t('SeeCar')}
                        </Typography>
                    </div>
                    <Typography color="white" variant="body2">
                        {t('SeeCarDescription')}
                    </Typography>
                </div>
                {!IS_DESKTOP && (
                    <button
                        className={styles.learn_more_button}
                        onClick={() => setShowLabel(!showLabel)}
                        style={{
                            gridArea: 's',
                            width: '90%',
                            justifySelf: 'center',
                            marginBottom: '16px',
                        }}
                    >
                        <Typography variant={'body2Medium'}>
                            {t('learn more')}
                        </Typography>
                    </button>
                )}
            </div>
        );
    };
    const card = () => {
        return (
            <div
                className={styles.reserve_see_container}
                /* @ts-ignore */
                variant="card"
                style={{
                    backgroundColor: '#002d5d',
                    display: 'grid',
                    gridTemplateAreas: '"r" "d" "b" "s"',
                    height: '100%',
                    gap: '10px',
                }}
            >
                <div
                    className={styles.content_container}
                    style={{ gridArea: 'r' }}
                    /* @ts-ignore */
                    rtl={IS_RTL ? 'rtl' : 'ltr'}
                    variant={'card'}
                >
                    <div className={styles.header_container}>
                        <img
                            src={ShieldTick.src}
                            alt=""
                            fetchPriority={'low'}
                        />
                        <Typography color="white" variant="subtitle2Bold">
                            {t('ReserveCar')}
                        </Typography>
                    </div>
                    <Typography color="white" variant="body2">
                        {t('ReserveCarDescription')}
                    </Typography>
                </div>
                <div
                    style={{
                        height: '1px',
                        backgroundColor: '#98a2b3',
                        gridArea: 'd',
                        margin: '0px 16px',
                    }}
                ></div>
                {/* @ts-ignore */}
                <div
                    className={styles.content_container}
                    style={{ gridArea: 'b' }}
                >
                    <div className={styles.header_container}>
                        <img
                            src={SeeCarIcon.src}
                            alt=""
                            fetchPriority={'low'}
                        />
                        <Typography color="white" variant="subtitle2Bold">
                            {t('SeeCar')}
                        </Typography>
                    </div>
                    <Typography color="white" variant="body2">
                        {t('SeeCarDescription')}
                    </Typography>
                </div>

                <button
                    className={`${styles.learn_more_button} max-h-[50px]`}
                    onClick={() => setShowLabel(!showLabel)}
                    style={{
                        gridArea: 's',
                        width: '89%',
                        justifySelf: 'center',
                        // aspectRatio: '89/13',
                    }}
                >
                    <Typography variant={'body2Medium'}>
                        {t('learn more')}
                    </Typography>
                </button>
            </div>
        );
    };
    return (
        <>
            {IS_DESKTOP && variant === 'banner' && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '8px',
                    }}
                >
                    <Typography variant="body2Medium" color="#002D5D">
                        {t('ReserveVsSee')}
                    </Typography>
                    <div
                        onClick={() => setShowLabel(true)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                        }}
                    >
                        <Typography variant="body2Medium" color="#002D5D">
                            {t('learn more')}
                        </Typography>
                        {lang === 'ar' ? (
                            <ChevronLeft sx={{ color: '#002D5D' }} />
                        ) : (
                            <ChevronRight sx={{ color: '#002D5D' }} />
                        )}
                    </div>
                </div>
            )}
            {variant === 'banner' ? banner() : card()}

            <Modal
                open={showLabel}
                setOpen={setShowLabel}
                sx={{ backdropFilter: 'blur(3px)' }}
            >
                <div className={styles.modal}>
                    <div className={styles.reserveModalCarContainer}>
                        <Typography
                            variant="subtitle1Bold"
                            className={styles.modalTypography}
                        >
                            <img
                                src={ShieldTickModal.src}
                                className={styles.modalIcon}
                                alt="Shield tick"
                                fetchPriority={'low'}
                            />
                            {t('ReserveCar')}
                        </Typography>
                        <Typography
                            className={styles.description}
                            variant="caption"
                        >
                            {t('ReserveCarDescription')}
                        </Typography>

                        <div className={styles.itemsContainer}>
                            {RESERVE_MODAL_SECTIONS.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={styles.itemContainer}
                                    >
                                        <div className={styles.headerContainer}>
                                            <div
                                                className={
                                                    styles.itemHeaderContainer
                                                }
                                            >
                                                <img
                                                    src={item.icon.src}
                                                    className={styles.icon}
                                                    alt="itemIcon"
                                                />
                                                <Typography
                                                    variant="body2Bold"
                                                    className={styles.title}
                                                >
                                                    {t(
                                                        item.title as unknown as TemplateStringsArray
                                                    )}
                                                </Typography>
                                            </div>
                                            <Typography
                                                variant="body2Bold"
                                                className={styles.price}
                                            >
                                                {item.price}
                                            </Typography>
                                        </div>
                                        <div
                                            className={styles.benefitsContainer}
                                        >
                                            {item.benefits.map(
                                                (benefit, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={
                                                                styles.benefitContainer
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    benefit.icon
                                                                        .src
                                                                }
                                                                className={
                                                                    styles.icon
                                                                }
                                                                alt="benefitIcon"
                                                            />
                                                            <Typography variant="caption">
                                                                {benefit.text}
                                                            </Typography>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Divider className={styles.divider} />
                    <div className={styles.reserveModalCarContainer}>
                        <Typography
                            variant="subtitle1Bold"
                            className={styles.modalTypography}
                        >
                            <img
                                src={See.src}
                                className={styles.modalIcon}
                                alt="Shield tick"
                            />{' '}
                            {t('SeeCar')}
                        </Typography>
                        <Typography
                            variant="caption"
                            className={styles.description}
                        >
                            {t('SeeCarDescription')}
                        </Typography>

                        <div className={styles.benefitsContainer}>
                            {SEE_MODAL_SECTIONS.map((benefit, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={styles.benefitContainer}
                                    >
                                        <img
                                            src={benefit.icon.src}
                                            className={styles.icon}
                                            alt=""
                                        />
                                        <Typography variant="caption">
                                            {benefit.text}
                                        </Typography>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
